const translations = {
  "common": {
    callUs: "اتصل بنا",
    emailUs: "راسلنا",
  },
  "whatsapp": "واتساب",
  "twitter": "تويتر",
  "instagram": "انستغرام",
  errors: {
    go_home: "العودة إلى الصفحة الرئيسية",
    not_found: "الصفحة غير موجودة",
    not_found_message: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    try_again: "حاول مرة أخرى",
    unexpected: "عذراً! حدث خطأ غير متوقع",
    unexpected_message: "واجهنا خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
    server_error: "خطأ في الخادم",
    server_error_message: "خوادمنا تواجه مشاكل حالياً. يرجى المحاولة مرة أخرى بعد قليل.",
    offline: "أنت غير متصل",
    offline_message: "يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى."
  },
  about: {
    operating: 'دول التشغيل',
    expereince: 'سنوات من التميز',
    clients: "رضا العملاء",
    since: "منذ",
  },
  loading: "تحميل",
  fullscreen: "عرض بالكامل",
  quote_btn: "عرض سعر",
  learn_more: "المزيد",
  mission: {
    title: "مهمتنا",
    description: "وصف مهمتنا"
  },
  coreValues: {
    title: "قيمنا"
  },
  contact: {
    header_h1: "ابنِ أحلامك معنا",
    header_h2: "حول رؤيتك إلى واقع مع خدمات البناء المتخصصة لدينا. دعنا نناقش مشروعك ونحققه",
    title: "تواصل",
    titleColored: "معنا",
    subtitle: "هل لديك أسئلة؟ نحن هنا للمساعدة. أرسل لنا رسالة وسنرد في أقرب وقت ممكن.",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    message: "الرسالة",
    sendMessage: "إرسال الرسالة",
    connectWithUs: "تواصل معنا",
    emailUs: "راسلنا",
    callUs: "اتصل بنا",
    linkedin: "لينكد إن",
    twitter: "تويتر",
    connectWith: "تواصل معنا",
    followUs: "تابعنا",
    viewMap: "عرض على الخريطة",
    hero_title: "ابنِ أحلامك معنا",
    hero_subtitle: "حول رؤيتك إلى واقع مع خدمات البناء المتخصصة لدينا. دعنا نناقش مشروعك ونحققه",
    lets_connect: "لنتواصل",
    chat_with_us: "تحدث معنا",
    success_message: "تم إرسال الطلب بنجاح!",
    form: {
      request_quote: "طلب عرض سعر",
      full_name: "الاسم الكامل",
      phone: "رقم الهاتف",
      email: "البريد الإلكتروني",
      company: "الشركة",
      request_type: "نوع الطلب",
      message: "الرسالة",
      required: "هذا الحقل مطلوب",
      message_placeholder: "أخبرنا المزيد عن مشروعك...",
      invalid_email: "يرجى إدخال بريد إلكتروني صحيح",
      invalid_phone: "يرجى إدخال رقم هاتف صحيح",
      success: "تم إرسال رسالتك بنجاح!",
      error: "حدث خطأ في إرسال رسالتك. يرجى المحاولة مرة أخرى.",
      submit: "إرسال الطلب",
      submitting: "جاري الإرسال...",
      validation_error: "يرجى تصحيح الأخطاء في النموذج قبل الإرسال.",
      success_message: "تم تقديم طلبك بنجاح!",
      error_message: "حدث خطأ أثناء تقديم طلبك. يرجى المحاولة مرة أخرى."
    },
    social: {
      follow: "تابعنا على",
      connect: "تواصل معنا على",
      share: "شارك على",
      whatsapp: "واتساب",
      facebook: "فيس بوك",
      twitter: "تويتر",
      instagram: "انستغرام",
      linkedin: "لينكد إن",
      x: "إكس"
    },
    labels: {
      company: "الشركة",
      working_hours: "ساعات العمل",
      get_directions: "الحصول على الاتجاهات",
      social_links: "روابط التواصل الاجتماعي",
      quick_contact: "اتصال سريع"
    },
    aria: {
      contact_form: "نموذج طلب التواصل",
      social_links: "روابط وسائل التواصل الاجتماعي",
      contact_info: "معلومات الاتصال",
      submit_button: "إرسال نموذج الاتصال",
      close_message: "إغلاق الرسالة"
    }
  },
  services: {
    titleStart: "",
    titleColored: "خدماتنا",
    subtitle: "اكتشف مجموعتنا الشاملة من حلول البناء والهندسة المصممة لتلبية احتياجاتك الخاصة.",
    overview: "نظرة عامة",
    features: "مميزات",
    benefits: "فوائد",
    our_services: "خدماتنا",
    gallery: "معرض الصور",
  },
  projects: {
    title: "مشاريعنا",
    selected_projects: "مشاريعنا المختارة",
    overview: "نظرة عامة",
    panorama: "بانوراما",
    gallery: "معرض المشروع",
    type: "نوع المشروع",
    city: "المدينة",
    year: "سنة المشروع",
    cost: "تكلفة المشروع",
    ongoing: "قيد التنفيذ",
    completed: "منجز",
    location: "الموقع",
  },
  footer: {
    navigation: "القائمة", 
    services: "الخدمات",
    contact: "تواصل معنا",
    copyright: "© {{year}} شركة يونستون. جميع الحقوق محفوظة."
  },
  validation: {
    required: "هذا الحقل مطلوب",
    name_min_length: "يجب أن يتكون الاسم من 3 أحرف على الأقل",
    email_invalid: "يرجى إدخال بريد إلكتروني صحيح",
    message_min_length: "يجب أن تتكون الرسالة من 10 أحرف على الأقل"
  }
};

export default translations;
